<template>
  <!-- 版本 -->
  <v-card-text class="version-content pa-0">
    <v-slide-x-transition mode="out-in">
      <v-tabs vertical>
        <v-tab v-for="(item, index) in tabs" :key="index" background-color="transparent"
          @click.stop="clickVersion(item)">
          <v-icon left> mdi-file-clock </v-icon>
          {{ item }}
        </v-tab>

        <v-tab-item v-for="(item, key) in tabs" :key="'conetent-' + key" class="bg-transparent">
          <v-card class="bg-transparent" flat>
            <v-card-text class="pa-0">
              <v-list class="pa-0">
                <template v-for="(content, c_i) in versionData[item]">
                  <v-list-item :key="'content-' + c_i">
                    <v-list-item-content>
                      <v-list-item-title class="font-weight-bold">
                        <v-chip class="ma-2" :color="getColor(content.type)" small outlined>
                          {{ content.type }}
                        </v-chip>
                        {{
                          content[lang === 'cn' ? `topic` : `topicEn`]
                            ? content[lang === 'cn' ? `topic` : `topicEn`]
                                                : content.topic
                        }}
                        <v-btn plain small icon :href="content.url"
                          target="_blank"><v-icon>mdi-link-variant</v-icon></v-btn>
                      </v-list-item-title>
                      <v-list-item-subtitle class="pt-10-px pl-74-px" style="white-space: pre-wrap">{{
                        content[lang === 'cn' ? `desc` : `descEn`]
                          ? content[lang === 'cn' ? `desc` : `descEn`]
                                              : content.desc
                      }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider v-if="c_i < item.length - 1" :key="c_i"></v-divider>
                </template>
              </v-list>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs>
    </v-slide-x-transition>
  </v-card-text>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  name: 'BriefList',

  data() {
    return {
      tabIndex: null
    }
  },

  computed: {
    ...mapState('common', ['modifyMode', 'lang']),
    ...mapState('document', ['versionData', 'allChapterList']),
    tabs() {
      return Object.keys(this.versionData)
    }
  },

  watch: {
    versionData: {
      handler: function (newVal) {
        const keys = Object.keys(newVal)
        if (keys.length > 0) {
          this.clickVersion(newVal[keys[0]], keys[0])
        }
      },
      deep: true
    }
  },

  mounted() {
    this.tabIndex = 0
  },

  methods: {
    ...mapActions('document', ['setCreateMode']),
    getColor(type) {
      switch (type) {
        case '更新':
          return 'orange'
        case '新增':
          return 'blue'
        case '刪除':
          return 'red'
        case '修改':
          return 'green'
        default:
          return 'grey'
      }
    },
    clickVersion(date) {
      if (this.modifyMode.show) {
        const data = this.versionData[date]
        for (const i in data) {
          const curr = data[i]
          const currMenu = this.allChapterList.find(
            (item) => item.menuId === curr.menuId
          )
          curr.level = currMenu.level
        }
        const newData = { online: date, briefs: data }
        this.setCreateMode({ obj: newData, mode: 0 })
      } else {
        this.setCreateMode({ obj: {}, mode: -1 })
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
